import React from "react";

import { useSearchParams } from "../../hooks/useSearchParams";

import RestoreRequest from "./RestoreRequest";
import CartPage from "./CartPage";
import SearchPage from "./SearchPage";

/**
  delegate different views to view-specific components
 */
const PageBrancher = (props) => {
  const { restoreid, cart } = useSearchParams();

  // the restored files page
  if (restoreid) {
    return <RestoreRequest {...props} />;
  }

  // the cart page
  if (cart) {
    return <CartPage {...props} />;
  }

  // the general search page
  return <SearchPage {...props} />;
};

export default PageBrancher;
